<template>
  <!-- 头部整体盒子 -->
  <div>
    <div id="header" class="container-fluid">
      <!-- 头部顶部 -->

      <!-- 电脑导航 -->
      <div class="header-nav container-fluid hidden-xs">
        <!-- 导航logo -->
        <div class="header-nav-logo">
          <img src="@/assets/img/logo.png" alt="">
          <!-- <p class="logo-text" translate="no">{{ $dt('logo') }}</p> -->
        </div>
        <!-- 导航内容 -->
        <ul class="header-nav-wrapper">
          <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name, item)">
            <router-link :to="item.path">
              {{ item.name }}
              <span v-if="item.xia" class="glyphicon glyphicon-menu-down"></span>
              <i class="underline"></i>
            </router-link>

            <!--产品-->
            <dl ref="menuElement" v-if="item.children.length" :style="menuStyle"
              @mouseenter="handleMenuEnterthree(item)" @mouseleave="handleMenuLeavethree(item)">
              <a-menu @mouseleave="handleMenuEnterthree(item)" style="min-width: 110px" mode="vertical">
                <template v-for="menuItem in menuData">
                  <a-sub-menu @mouseenter="handleMenuEnterthree(item)" @mouseleave="handleMenuLeavethree(item)"
                    v-if="menuItem.children && menuItem.children.length" :key="menuItem.id" :title="menuItem.id"
                    style="min-width: 110px">
                    <template v-for="subItem in menuItem.children">
                      <a-sub-menu @mouseenter="handleMenuEnterthree(item)" @mouseleave="handleMenuLeavethree(item)"
                        v-if="subItem.children && subItem.children.length" :key="subItem.id" :title="subItem.name"
                        style="min-width: 110px">
                        <template v-for="childItem in subItem.children">
                          <a-menu-item @mouseenter="handleMenuEnterthree(item)" @mouseleave="handleMenuLeavethree(item)"
                            :key="childItem.id" @click="closeMenu(subItem, childItem)">
                            <router-link :to="'/product' + subItem.path + 'Page/' + childItem.id">
                              {{ childItem.name.length > 50 ? childItem.name.slice(0, 50) + '...' : childItem.name }}
                              <!--                              {{ childItem.name }}-->
                            </router-link>
                          </a-menu-item>
                        </template>
                      </a-sub-menu>
                      <a-menu-item @mouseenter="handleMenuEnterthree(item)" @mouseleave="handleMenuLeavethree(item)"
                        v-else :key="subItem.id" @click="closeMenu(subItem, subItem)">
                        <router-link :to="'/product' + subItem.path + 'Page/' + subItem.id"> {{
                          subItem.name
                        }}
                        </router-link>
                        {{ subItem.name }}
                      </a-menu-item>
                    </template>
                  </a-sub-menu>
                  <a-menu-item v-else :key="menuItem.id">{{ menuItem.id }}</a-menu-item>
                </template>
              </a-menu>
            </dl>

            <!--解决方案-->
            <dl v-if="item.children4.length">
              <dt v-for="solution in item.children4" :key="solution.id + 'c'">
                <router-link :to="'/solutionDetail/' + solution.id">{{ solution.solutionTitle }}</router-link>
              </dt>
            </dl>
            <!--加入我们-->
            <dl v-if="item.children5">
              <dt v-for="joinUs in item.children5">
                <router-link :to="joinUs.path">{{ joinUs.name }}</router-link>
              </dt>
            </dl>
          </li>
          <li>
            <a href="javascript:void(0);" @click="switchLang">
              <!-- <a href="javascript:void(0);" @click="toggleLanguage"> -->
              {{ currentLang === 'zh' ? 'English' : '中文' }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="../assets/img/logo.png" alt="logo">
      </div>
      <div class="button-container">
        <a-button type="primary" @click="showDrawer">
          <a-icon type="menu-unfold" />
        </a-button>
        <a-drawer :title="$dt('logo')" placement="right" :closable="false" :visible="visible"
          :after-visible-change="afterVisibleChange" @close="onClose">
          <div>
            <a-menu style="width: 256px" :open-keys.sync="openKeys" mode="inline" @click="handleClick">
              <template v-for="(item, index) in navList">
                <!-- 判断是否有下拉 -->
                <a-sub-menu v-if="item.xia" :key="index" @titleClick="titleClick">
                  <span slot="title">
                    <router-link :to="item.path">
                      <span style="display:inline-block;height: 100%;width: 85%">{{ item.name }}</span>
                    </router-link>
                  </span>

                  <!-- 根据 item 类型显示不同的子菜单 -->
                  <template v-if="item.type === 'product'">
                    <a-menu-item-group v-if="item.children && item.children.length > 0"
                      :title="$dt('productList.instrument')">
                      <!-- <div > -->
                      <a-menu-item v-for="(i, n) in item.children" :key="n + 'b'">
                        <router-link :to="'/product/instrumentPage/' + i.id" class="horizontal-scrollbar">{{ i.name }}
                        </router-link>
                      </a-menu-item>
                      <!-- </div> -->
                    </a-menu-item-group>

                    <a-menu-item-group v-if="item.children3 && item.children3.length > 0"
                      :title="$dt('productList.reagent')">
                      <a-menu-item v-for="point in item.children3" :key="point.id + 'c'">
                        <router-link :to="'/product/reagentPage/' + point.id" class="horizontal-scrollbar">{{
                          point.name
                        }}
                        </router-link>
                      </a-menu-item>
                    </a-menu-item-group>

                    <a-menu-item-group v-if="item.children2 && item.children2.length > 0"
                      :title="$dt('productList.software')">
                      <a-menu-item v-for="node in item.children2" :key="node.id + 'a'">
                        <router-link :to="'/product/softwarePage/' + node.id" class="horizontal-scrollbar">{{
                          node.name
                        }}
                        </router-link>
                      </a-menu-item>
                    </a-menu-item-group>
                  </template>

                  <!-- 解决方案类型 -->
                  <template v-else-if="item.type === 'solution'">
                    <a-menu-item v-for="(i, n) in item.children4" :key="n + 'c'">
                      <router-link :to="'/solutionDetail/' + i.id" class="horizontal-scrollbar">{{
                        i.solutionTitle
                      }}
                      </router-link>
                    </a-menu-item>
                  </template>
                  <!--关于我们 联系我们-->
                  <template v-else-if="item.children5">
                    <a-menu-item v-for="joinUs in item.children5" :key="joinUs.id">
                      <router-link :to="joinUs.path" class="horizontal-scrollbar">{{ joinUs.name }}</router-link>
                    </a-menu-item>
                  </template>
                </a-sub-menu>

                <!-- 没有下拉的情况 -->
                <a-menu-item v-else :key="index">
                  <router-link :to="item.path" class="horizontal-scrollbar">{{ item.name }}</router-link>
                </a-menu-item>
              </template>

              <!-- 单独的语言切换项 -->
              <a-menu-item key="lang-switcher">
                <a href="javascript:void(0);" @click="switchLang">
                  {{ currentLang === 'zh' ? 'English' : '中文' }}
                </a>
              </a-menu-item>
            </a-menu>
          </div>
        </a-drawer>
      </div>
    </div>
  </div>
</template>
<script>
import { getAction } from '../api/manage'
// import { $dt } from '../i18n/$dt.js'


export default {
  name: "Header",
  data() {
    return {

      isMouseInMenu: false,

      isOpen: {}, // 控制每个 li 下的展开/收起状态

      subMenuPosition: { x: 0, y: 0 }, // 控制子菜单的位置

      menuData: [],

      menuStyle: {
        "display": 'node',
        "minWidth": '110px',
      },



      language: 'zh',
      current: ['mail'],
      openKeys: ['sub1'],
      visible: false,
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "主页",
      menuClass: "glyphicon glyphicon-menu-down",
      currentLang: 'zh'
    };
  },

  computed: {
    navList() {
      return [
        {
          name: this.$dt('common.home'),
          path: "/",
          children: [],
          children2: [],
          children3: [],
          children4: []
        },
        {
          type: 'product', // 表示这是一个有下拉的产品菜单
          name: this.$dt('common.product'), // 代替 "产品"
          // name: "产品",
          path: "",
          xia: true,
          children: [],
          children2: [],
          children3: [],
          children4: []
        },
        {
          name: this.$dt('common.solution'), // 代替 "解决方案"
          path: "",
          xia: true,
          type: 'solution',
          children: [],
          children2: [],
          children3: [],
          children4: []
        },
        {
          name: this.$dt('common.newsCenter'), // 代替 "新闻中心"
          path: "/newsCenter",
          children: [],
          children2: [],
          children3: [],
          children4: []
        },
        {
          name: this.$dt('common.collaboration'), // 代替 "科研合作"
          path: "/aboutUs4",
          children: [],
          children2: [],
          children3: [],
          children4: []
        },
        {
          name: this.$dt('common.achievements'), // 代替 "科研成果"
          path: "/aboutUs5",
          children: [],
          children2: [],
          children3: [],
          children4: []
        },
        /*{
          name: this.$dt('common.Documents'), // 文件
          path: "/newsCenter",
          xia: true,
          children: [],
          children2: [],
          children3: [],
          children4: [],
          children5: [
            {
              name: this.$dt('common.Certificattion'),
              path: "/aboutUs2",
            }, {
              name: this.$dt('common.ApplicationNotes'),
              path: "/aboutUs2",
            }, {
              name: this.$dt('common.Publications'),
              path: "/aboutUs2",
            }, {
              name: this.$dt('common.SafetyDataSheets'),
              path: "/aboutUs2",
            },
          ],
        },*/
        {
          name: this.$dt('common.aboutUs'), // 代替 "关于我们"
          xia: true,
          // path: "/aboutUs",
          path: "",
          children: [],
          children2: [],
          children3: [],
          children4: [],
          children5: [
            {
              name: this.$dt('AboutUs.about1'),
              path: "/aboutUs1",
            }, {
              name: this.$dt('AboutUs.about2'),
              path: "/aboutUs2",
            },{
              name: this.$dt('AboutUs.about3'),
              path: "/aboutUs3",
            },
            {
              name: this.$dt('AboutUs.about4'),
              path: "/aboutUs4",
            },
            {
              name: this.$dt('AboutUs.about5'),
              path: "/aboutUs5",
            },
            {
              name: this.$dt('AboutUs.about6'),
              path: "/aboutUs6",
            },
          ],
        },
        {
          name: this.$dt('common.contactUs'), // 代替 "联系我们"
          // path: "/contactus",
          xia: true,
          path: "",
          children: [],
          children2: [],
          children3: [],
          children4: [],
          children5: [
            {
              name: this.$dt('common.contactUs'),
              path: "/contactus",
            }, {
              name: this.$dt('common.joinUs'),
              path: "/recruitment",
            },
          ],
        },
        // {
        //   name: "人才招聘",
        //   path: "/recruitment",
        //   children: [],
        //   children2: [],
        //   children3: [],
        //   children4: []
        // }
      ]
    }
  },
  /* watch: {
    openKeys(val) {
      console.log('openKeys', val);
    },
  }, */
  methods: {

    closeMenu(subItem, childItem) {
      console.log('closeMenu', subItem, childItem);
      console.log('closeMenu2', '/product' + subItem.path + '/' + childItem.id);
      this.menuStyle.display = 'none'
    },

    // 翻译
    languageAuto(type) {
      // this.language = type
      // localStorage.setItem('language', `{"language":"${this.language}"}`)
      // if (this.language === 'zh') {
      //   // console.log(this.$translate)
      //   this.$translate.changeLanguage('chinese_simplified')
      // }
      // if (this.language === 'en') {
      //   // console.log(this.$translate)
      //   this.$translate.changeLanguage('english')
      // }
      //todo
      // this.$translate.execute() //进行翻译
    },
    // 手机导航菜单
    handleClick(e) {
      console.log('click', e);
    },
    titleClick(e) {
      console.log('titleClick', e);
    },
    // 抽屉
    afterVisibleChange(val) {
      console.log('visible', val);
    },
    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    navClick(index, name, item) {
      // 产品是否打开
      if ("产品" === name || "Products" === name) {  // 建议用严格相等运算符
        // 核心切换逻辑
        this.menuStyle.display = this.menuStyle.display === 'block' ? 'none' : 'block';
        console.log('状态切换:', this.menuStyle.display);
      }
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    handleMenuEnterdl(item) {
      if (item.type === 'product') {
        console.log('鼠标移入dl')
        this.menuStyle.display = 'block'

      }
    },
    handleMenuLeavedl(item) {
      if (item.type === 'product') { // 添加延迟关闭避免误触
        setTimeout(() => {
          // console.log('鼠标移出dl')
          // this.menuStyle.display = 'none'
        }, 300)
      }
    },
    handleMenuLeavemain(item) {
      if (item.type === 'product') { // 添加延迟关闭避免误触
        setTimeout(() => {
          // console.log('鼠标移出main')
          // this.menuStyle.display = 'none'
        }, 300)
      }
    },
    handleMenuLeaveone(item) {
      console.log('鼠标移出1111111e')
      if (item.type === 'product') { // 添加延迟关闭避免误触
        // console.log('鼠标移出one')
        // this.menuStyle.display = 'none'
      }
    },
    handleMenuLeavetwo(item) {
      if (item.type === 'product') { // 添加延迟关闭避免误触
        //  console.log('鼠标移出two')
        //  this.menuStyle.display = 'none'
      }
    },
    handleMenuEnterthree(item) {
      if (item.type === 'product') {
        // console.log('鼠标移入three')
        this.isMouseInMenu = true; // 设置状态为"在菜单内"
        this.menuStyle.display = 'block'; // 显示菜单
      }
    },
    handleMenuLeavethree(item) {
      if (item.type === 'product') {
        // console.log('鼠标移出three')
        this.isMouseInMenu = false; // 设置状态为"离开菜单"
        this.handleGlobalMenuLeave(); // 触发全局检查
      }
    },
    // 延迟全局判断是否要关闭
    handleGlobalMenuLeave() {
      // 延迟100ms检查，确保鼠标移动稳定
      setTimeout(() => {
        // 只有当鼠标完全离开菜单区域时才关闭
        if (!this.isMouseInMenu) {
          this.menuStyle.display = 'none';
        }
      }, 3000);
    },

    // 加载仪器导航
    loadInstrumentNav() {
      // 查询条件
      let queryParam = {
        currentPage: 1,
        pageSize: -1,
        search: {
          isNav: '1',
          name: '',
          remark: ''
        }
      }
      getAction('/instrument/list', queryParam).then((res) => {

        this.$set(this.navList[1], 'children', res.data.data.rows);
        console.log('查询仪器导航结果', res.data.data.rows);
        // this.navList[1].children = res.data.data.rows;
      })
      getAction('/instrument/getProductMenu', queryParam).then((res) => {
        this.menuData = res.data.data.rows;
        console.log('查询产品菜单结果', res.data.data.rows);
        // this.navList[1].children = res.data.data.rows;
      })

    },
    // 加载试剂导航
    loadSoftwareNav() {
      // 查询条件
      let queryParam = {
        currentPage: 1,
        pageSize: -1,
        search: {
          id: '',
        }
      }
      getAction('/software/list', queryParam).then((res) => {
        this.$set(this.navList[1], 'children2', res.data.data.rows);
        // this.navList[1].children2 = res.data.data.rows;
      })

    },
    // 加载软件导航
    loadReagentNav() {
      // 查询条件
      let queryParam = {
        currentPage: 1,
        pageSize: -1,
        search: {
          isNav: '1',
        }
      }
      getAction('/reagent/list', queryParam).then((res) => {
        this.$set(this.navList[1], 'children3', res.data.data.rows);
        // this.navList[1].children3 = res.data.data.rows;
      })
    },
    //加载解决方案导航
    loadSolutionNav() {
      // 查询条件
      let queryParam = {
        currentPage: 1,
        pageSize: -1,
        search: {}
      }
      getAction('/solution/list', queryParam).then((res) => {
        this.$set(this.navList[2], 'children4', res.data.data.rows);
        // this.navList[2].children4 = res.data.data.rows;
      })
    },



    switchLang() {
      debugger;
      const newLang = this.currentLang === 'zh' ? 'en' : 'zh'
      this.$i18n.locale = newLang
      console.log('语言包内容是', this.$i18n.messages[this.$i18n.locale])
      this.currentLang = newLang
      document.documentElement.lang = newLang
      localStorage.setItem('lang', newLang)
      const messages = this.$i18n.messages[this.$i18n.locale]
      localStorage.setItem('messages', JSON.stringify(messages))
      window.location.reload();
      this.loadInstrumentNav();
      this.loadSoftwareNav();
      this.loadReagentNav();
      this.loadSolutionNav();
      console.log('navList', this.navList);
    },


    // toggleLanguage() {
    //   const newLang = this.currentLang === 'zh' ? 'en' : 'zh'
    //   debugger;
    //   this.currentLang = newLang
    //   this.$root.$emit('language-changed', newLang)
    //   document.documentElement.lang = newLang
    //   localStorage.setItem('lang', newLang)

    //   // 添加自动翻译功能
    //   if (newLang === 'en') {
    //     this.$translate.changeLanguage('english')
    //   } else {
    //     this.$translate.changeLanguage('chinese_simplified')
    //   }
    //   this.$translate.execute() // 执行翻译
    // }

  },
  created() {
    this.loadInstrumentNav();
    this.loadSoftwareNav();
    this.loadReagentNav();
    this.loadSolutionNav();
    console.log('navList', this.navList);
    this.currentLang = localStorage.getItem('lang') || 'zh'
    this.$i18n.locale = this.currentLang

    const messages = this.$i18n.messages[this.$i18n.locale]
    localStorage.setItem('messages', JSON.stringify(messages))

  },

  mounted() {
  }
};
</script>
<style>
/* 顶部 */
#header {
  background: #fff;
  transition: all ease 0.6s;
  z-index: 999;
}

#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav {
  height: 75px;
  margin: 30px 0;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 200px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: absolute;
  /* left: 50px; */
  top: -12px;
  align-items: center;
  margin: 30px 0;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 300px;
  height: 90px;
}

/* 导航栏logo文字 */
#header .header-nav .header-nav-logo .logo-text {
  font-size: 20px;
  font-weight: bold;
  color: #565656;
  margin: 0;
  font-family: cursive;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 40px;
  float: right;
  margin: 0;
  max-width: 1000px;
  display: flex;
  justify-content: flex-end;
  flex-wrap: nowrap;
}

.submenu-item {
  position: relative;
  cursor: pointer;
}

.submenu-header {
  padding: 8px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.arrow {
  transition: transform 0.3s ease;
}

.arrow.open {
  transform: rotate(90deg);
}

.submenu-level3 {
  position: absolute;
  top: 0;
  left: 100%;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  min-width: 150px;
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.submenu-level3 li {
  padding: 8px 12px;
}

.submenu-level3 li:hover {
  background-color: #f0f0f0;
}

/* 动画效果 */
.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper>li {
  float: left;
  margin: 0 10px;
  position: relative;
  white-space: nowrap;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper>li>a {
  font-weight: 500;
  color: #000000;
  font-size: 18px;
  padding: 15px 5px;
  position: relative;
  display: inline-block;
  min-width: 60px;
  text-align: center;
  text-transform: capitalize;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper>li>a>i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #448ef7;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper>li>a>span {
  font-size: 15px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover {
  color: #448ef7;
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper>li.active>a {
  color: #448ef7;
  text-decoration: none;
  border-bottom: 2px solid #448ef7;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper>li>dl {
  border-radius: 2px;
  display: none;
  position: absolute;
  min-width: 200px;
  width: auto;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 1px 1px #f3f3f3;
  background: #fff;
  padding: 15px 0 15px 0;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper>li>.divdl {
  border-radius: 2px;
  display: none;
  position: absolute;
  min-width: 200px;
  width: auto;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 1px 1px #f3f3f3;
  background: #000000;
  padding: 15px 0 15px 0;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper>li>dl>dt {
  width: 100%;
  padding: 10px;
  white-space: nowrap;
}

#header .header-nav .header-nav-wrapper>li>dl>dt>a {
  width: 100%;
  height: 100%;
  text-decoration: none;
  display: block;
  font-weight: lighter;
  color: #777777;
  padding: 0 15px;
  box-sizing: border-box;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
  text-decoration: none;
  background: #448ef7;
  color: white;
}

/* 调整下拉菜单的位置，防止溢出 */
#header .header-nav .header-nav-wrapper>li:last-child>dl {
  right: 0;
  left: auto;
}

/* 确保下拉菜单内容不会换行 */
#header .header-nav .header-nav-wrapper>li>dl>dt h5 {
  margin: 0;
  padding: 0;
  font-weight: bold;
  color: #000000;
  white-space: nowrap;
}

#header .disabled {
  background: white;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper>li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
  cursor: pointer;
  background: #448ef7;
  color: white;
}

#header .header-nav .header-nav-wrapper>li>dl>dt:hover a {
  color: white;
}

#header .header-nav .header-nav-wrapper>li>dl>dt h5 {
  margin: 0;
  padding: 0;
  font-weight: bold;
  color: #000000;
}

#header .header-nav .header-nav-wrapper>li>dl>dt:hover h5 {
  color: #FFFFFF;
}

/* 语言切换按钮样式 */
#header .header-nav .header-nav-wrapper>li:last-child>a {
  color: #448ef7;
  font-weight: bold;
  min-width: 80px;
  text-transform: capitalize;
}

#header .header-nav .header-nav-wrapper>li:last-child>a:hover {
  color: #1890ff;
}

@media screen and (max-width: 1200px) {
  #header .header-nav .header-nav-wrapper>li>a {
    font-size: 16px;
    padding: 15px 3px;
  }

  #header .header-nav .header-nav-wrapper {
    max-width: 800px;
  }
}

@media screen and (max-width: 997px) {
  #header .header-nav .header-nav-wrapper {
    display: none;
  }

  #header .header-nav-m {
    position: relative;
    display: flex;
    justify-content: space-between;
    /* 将子元素在主轴（水平方向）上均匀分布 */
    align-items: center;
    /* 垂直居中对齐 */
  }

  .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
    margin: 0;
    padding: 0;
  }

  .header-nav-m .header-nav-m-logo img {
    width: auto;
    height: 60px;
    margin-left: 30px;
    margin-top: 15px;
  }

  .button-container {
    position: absolute;
    right: 22px;
    top: 25px;
  }

  /* 手机导航的横向滚动 */
  .horizontal-scrollbar {
    width: 100%;
    height: 100%;
    overflow-x: auto;
    white-space: nowrap;
    outline: none;
    /* 隐藏滚动条 */
    scrollbar-width: none;
    -ms-overflow-style: none;
    outline: none !important;
    /* 关键：明确水平滚动方向 */
    touch-action: pan-x;
  }

  #header .header-nav-m button {
    padding: 0;
    width: 50px;
    height: 45px;
    font-size: 27px;
    color: #373a47;
    border: transparent;
    background-color: transparent;
    position: absolute;
    right: 22px;
    top: 18px;
  }

  .ant-drawer-body {
    padding: 0;
  }

  a {
    color: #000c17;
    text-decoration: none;
  }

  a:hover {
    text-decoration: none;
  }

  .ant-menu-item .ant-dropdown-link {
    display: block;
    color: inherit;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue